<template>
<div>
  Dashboard
  <md-button class="md-fab md-fab-bottom-right md-primary" v-on:click="newUnitPlan">
    <md-icon>add</md-icon>
  </md-button>
</div>
</template>

<script>
// @ is an alias to /src
//import { db } from '../main'
import { createUnitPlan } from '../models/UnitPlan'
export default {
  name: 'dashboard',
  methods: {
    newUnitPlan: function() {
      createUnitPlan(this.$store.getters.user.uid).then(function(docRef) {this.$router.push('unit-plan/'+docRef.id)}.bind(this));
    }
  }
  
//   data() {
//     return {
//       standards: []
//     }
//   },
//   firestore() {
//     return {
//       standards: db.collection('standards')
//     }
//   }
}
</script>
<style lang="css" scoped>
  .md-card {
    max-width: 600px;
    margin: 4px;
    display: block;
    vertical-align: top;
  }
</style>


// WEBPACK FOOTER //
// src/views/Dashboard.vue